import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, Breadcrumb } from 'antd';
import Header from './components/layout/Header/Header';
import Aside from './components/layout/Aside/Aside';
import './app.less';
import './tantuer.less'; // tantuer skin

class App extends Component {
  constructor() {
    super();
    this.state = {
      isAdd: false,
      isEdit: false
    };
  }
  componentDidMount() {
    this.queryMenuList(this.props.children.props.location.pathname);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.children.props.location.pathname !==
      this.props.children.props.location.pathname
    ) {
      this.queryMenuList(nextProps.children.props.location.pathname);
    }
  }
  // 查询 menu list
  queryMenuList = pathname => {
    console.log(this.props.menu.length);
    if (this.props.menu.length === 0) {
      this.props
        .dispatch({ type: 'menu/queryMenuConfig', params: {} })
        .then(data => {
          this.highlight(data, pathname);
        });
    } else {
      this.highlight(this.props.menu, pathname);
    }
  };

  regPath = pathname => {
    const pathRegAdd = /.+(?=\/add)/;
    const pathRegEdit = /.+(?=\/\d+\/edit)/;
    const rePath = pathname.match(pathRegAdd) || pathname.match(pathRegEdit);
    const path = rePath === null ? pathname : rePath[0];
    this.setState({
      isAdd: pathname.match(pathRegAdd) ? true : false,
      isEdit: pathname.match(pathRegEdit) ? true : false
    });
    return path;
  };

  highlight = (data, path) => {
    const pathname = this.regPath(path);
    let currentIds = [];

    data.forEach(item => {
      if (pathname !== path) {
        const matchPathIds = this.toMatch(item, path);
        if (matchPathIds) {
          currentIds = matchPathIds;
        }
      }
      const matchPathnameIds = this.toMatch(item, pathname);
      if (matchPathnameIds) {
        currentIds = matchPathnameIds;
      }
    });
    const headHighlight = currentIds.splice(0, 1);
    this.props.dispatch({
      type: 'menu/updateHeadHighlight',
      ids: headHighlight
    });
    this.props.dispatch({ type: 'menu/updateAsideHighlight', ids: currentIds });
  };
  toMatch = (o, path) => {
    if (o.url === path) {
      return [o];
    }
    if (o.children && o.children.length) {
      for (var idx = 0; idx < o.children.length; idx++) {
        var tm = this.toMatch(o.children[idx], path);
        if (tm) {
          const arr = [o];
          tm.forEach(it => {
            arr.push(it);
          });
          return arr;
        }
      }
    }
  };
  renderBreadCrumb = () => {
    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          {this.props.headHighlight[0] && this.props.headHighlight[0].title}
        </Breadcrumb.Item>
        {this.props.asideHighlight.length > 0 &&
          this.props.asideHighlight.map(item => {
            return (
              <Breadcrumb.Item key={item.title}>
                <Link to={item.url}>{item.title}</Link>
              </Breadcrumb.Item>
            );
          })}
        {this.state.isAdd && <Breadcrumb.Item>添加</Breadcrumb.Item>}
        {this.state.isEdit && <Breadcrumb.Item>编辑</Breadcrumb.Item>}
      </Breadcrumb>
    );
  };

  render() {
    return (
      <Layout className="layout tantuer">
        <Layout.Header>
          <Header {...this.props} />
        </Layout.Header>
        <Layout>
          <Layout.Sider width="200">
            <Aside {...this.props} />
          </Layout.Sider>
          <Layout>
            <Layout.Content>
              {this.renderBreadCrumb()}
              <div className="content">{this.props.children}</div>
            </Layout.Content>
          </Layout>
        </Layout>
      </Layout>
    );
  }
}
function mapStateToProps(state) {
  return {
    ...state.menu
  };
}
export default connect(mapStateToProps)(App);
